"use client"
import { track } from "@opensea/analytics"
import { Link } from "@opensea/next-ui-kit"
import { FlexCenter, TextBody, UnstyledButton } from "@opensea/ui-kit"
import { Help } from "@opensea/ui-kit/icons"
import { useTranslations } from "next-intl"
import { useIntercom } from "@/components/support/IntercomProvider"
import { SUPPORT_URL } from "@/constants/constants"
import { Sound, usePlaySound } from "@/hooks/use-play-sound"

export function PageFooterSupportLink() {
  const intercom = useIntercom()
  const t = useTranslations("PageFooterSupportLink")
  const [playSelect] = usePlaySound(Sound.Select)

  const content = (
    <FlexCenter className="gap-1 text-text-secondary">
      <Help size={14} />
      <TextBody size="xs">{t("support")}</TextBody>
    </FlexCenter>
  )

  if (intercom.isEnabled) {
    return (
      <UnstyledButton
        onClick={() => {
          void track("Intercom footer click", { inApp: true })
          intercom.boot()
          intercom.show()
          playSelect()
        }}
      >
        {content}
      </UnstyledButton>
    )
  }

  return (
    <Link
      href={SUPPORT_URL}
      onClick={() => {
        void track("Intercom footer click", { inApp: false })
        playSelect()
      }}
      variant="unstyled"
    >
      {content}
    </Link>
  )
}
